module.exports = "<span class=\"q-required\">{{msg}}</span>"